<g clip-path="url(#a)" fill="currentColor">
    <path
        d="M16.687 2.56H8.674A2.02 2.02 0 0 0 6.66 4.572v2.62h1.685v-2.62c0-.185.152-.328.329-.328h8.013c.177 0 .329.143.329.328v8.51a.329.329 0 0 1-.329.329h-2.629v1.685h2.629a2.014 2.014 0 0 0 2.014-2.014v-8.51a2.025 2.025 0 0 0-2.014-2.014Z"
    />
    <path
        d="M12.044 7.194H4.04a2.014 2.014 0 0 0-2.015 2.014v4.785c0 .464.38.843.843.843.463 0 .842-.379.842-.843V9.208c0-.177.144-.33.33-.33h8.004c.177 0 .328.144.328.33v8.51a.329.329 0 0 1-.328.328H4.039a.324.324 0 0 1-.329-.328v-.506a.845.845 0 0 0-.842-.842.845.845 0 0 0-.843.842v.506c0 1.112.902 2.014 2.014 2.014h8.013a2.014 2.014 0 0 0 2.014-2.014v-8.51a2.026 2.026 0 0 0-2.022-2.014Z"
    />
</g>
<defs>
    <clipPath id="a">
        <path
            fill="#fff"
            transform="translate(2.026 2.56)"
            d="M0 0h16.667v17.172H0z"
        />
    </clipPath>
</defs>
